const faker = require('faker');
const ReactDataGrid = require('react-data-grid');
const React = require('react');

var listcolumns=[{
        key: 'userName',
        name: "用户名",
        width:285,
        resizable: true
      },
      {
        key: 'fileName',
        name: "表名",
        width:285,
        resizable: true
      }
    ];
export default class ExportDataGrid extends React.Component {
  constructor(props, context) {
    super(props, context);
    window.ListDataGrid=this;
    var rows=[];
    this.state = { rows:rows, selectedIndexes: []};
  }



  deleteRow=()=>{
   let rows=this.state.rows.slice();
   let selectedIndex=this.state.selectedIndexes[0];
   rows.splice(selectedIndex,1);
   this.setState({ rows:rows,selectedIndexes:[rows.length-1]});
  }

  getRowAt = (index) => {
    if (index < 0 || index > this.getSize()) {
      return undefined;
    }
    return this.state.rows[index];;

  };

  getSize = () => {
    return this.state.rows.length;
  };

  rowClick = (index,record,proxy) =>{
    this.setState({ selectedIndexes:[index]});
  }

  render() {
    return (
     
      <ReactDataGrid
        ref={ node => this.grid = node }
        enableCellSelect={true}
        columns={listcolumns}
        rowGetter={this.getRowAt}
        rowsCount={this.getSize()}
        onGridRowsUpdated={this.handleGridRowsUpdated}
        // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
        enableRowSelect={false}
        rowSelection={{
          showCheckbox: false,
          selectBy: {
            indexes: this.state.selectedIndexes
            
          }
        }}
        onRowClick={this.rowClick}//this.rowClick this.rowClick.bind(this)
        rowHeight={30}
        minHeight={200}
        rowScrollTimeout={500} />);
  }
}



// WEBPACK FOOTER //
// ./src/export/ListDataGrid.js